import { connect } from 'react-redux'
import { FinalResults } from '../components/FinalResults'

const FinalResultsContainer = connect()(FinalResults)

export default FinalResultsContainer